export default class GradientTextHandler {
    init() {
        // Find all elements with [data-gradient] that have !text-primary-4 class
        const gradientContainers = document.querySelectorAll('[data-gradient].\\!text-primary-4');
        
        gradientContainers.forEach(container => {
            this.updateTextColors(container);
        });
    }
    
    updateTextColors(container) {
        // Find all child elements with text-primary-1 or text-primary-5
        const elementsToUpdate = container.querySelectorAll('.text-primary-1, .text-primary-5');
        
        elementsToUpdate.forEach(element => {
            // Check if this element is inside a section with bg-gradient-to-b from-secondary-3 to-primary-4
            const gradientSection = element.closest('section.bg-gradient-to-b.from-secondary-3.to-primary-4');
            if (gradientSection && container.contains(gradientSection)) {
                return; // Skip this element
            }
            
            // Remove text-primary-1 and text-primary-5 classes
            element.classList.remove('text-primary-1', 'text-primary-5');
            // Add text-primary-4 class
            element.classList.add('text-primary-4');
        });
    }
}